import {useEffect, useRef} from 'react';

/** Runs `reset` when the scope key changes, and on mount only when a scope is already set. */
export const useResetOnScopeChange = (
  scopeKey: string | number | undefined,
  reset: () => void
) => {
  const resetRef = useRef(reset);
  resetRef.current = reset;
  const hasMounted = useRef(false);

  useEffect(() => {
    if (!hasMounted.current) {
      hasMounted.current = true;
      if (scopeKey === undefined) return;
    }
    resetRef.current();
  }, [scopeKey]);
};
